import { Fragment } from 'react';
import { BranchFormValues } from 'assets/js/pages/engage/workflows/actions/types';
import * as NodeBadges from 'assets/js/pages/engage/workflows/components/NodeBadges';

interface BranchCampaignsDisplayValueProps {
    value: BranchFormValues['value'];
}
const BranchTagsDisplayValue = ({ value }: BranchCampaignsDisplayValueProps) => {
    if (!value || 'operator' in value === false) return null;
    if (!value.tags || value.tags.length === 0) return null;

    return (
        <NodeBadges.Root>
            {value.tags.map((tag, index) => (
                <Fragment key={tag}>
                    <NodeBadges.Badge className="text-gray-900">{tag}</NodeBadges.Badge>
                    {value.tags.length > index + 1 ? (
                        <NodeBadges.Separator>
                            {value.operator === 'any' ? 'OR' : 'AND'}
                        </NodeBadges.Separator>
                    ) : null}
                </Fragment>
            ))}
        </NodeBadges.Root>
    );
};

export { BranchTagsDisplayValue };
